
import React from 'react';
import YouTube from 'react-youtube';
import './YouTubePlayer.css'; // Importing the CSS file

const YouTubePlayer = () => {
    const opts = {
        height: '315',
        width: '100%', // Default to 100% and let CSS handle responsiveness
        playerVars: {
            autoplay: 0,
        },
    };

    return (
        <div className="youtube-player">
            <div className="youtube-video">
                <YouTube videoId={'KeQreyXnrS4'} opts={opts} />
            </div>
            <div className="youtube-video">
                <YouTube videoId={'U7ybwunOeiw'} opts={opts} />
            </div>
        </div>
    );
};

export default YouTubePlayer;
